import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { User } from "@/api/users";
import { UserModal } from "./modals/userModal";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function UserChip({ userId }: { userId: number }) {
  const [item, setItem] = useState<User | null>(null);
  const disclosure = useDisclosure();
  const items = useAppSelector((state) => state.handbooks.user);

  useEffect(() => {
    if (userId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == userId) || null);
    }
  }, [userId, items]);

  return (
    <>
      <UserModal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        item={item!}
      />
      {userId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {userId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.first_name} {item?.last_name}
        </Chip>
      )}
      {userId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
